module.exports = __webpack_public_path__ + "img/mobile_menu_icon.68e40b76.webp";